import Api from '../apiGenerators/Api';
import { apiKeySelector } from '../auth/selectors';

/**
 * @deprecated replace with sagas
 * @param store
 * @returns {function(*=): Function}
 */
const employeeMiddleware = store => next => action => {
    next(action); // pass all actions through by default

    const apiKey = apiKeySelector(store.getState());
    const api = new Api(next, '/employees', 'EMPLOYEE', apiKey);

    switch (action.type) {
        case 'GET_SINGLE_EMPLOYEE':
            api.getSingle(action.id);
            break;

        case 'PUT_EMPLOYEE':
            api.put(action.data);
            break;

        case 'POST_EMPLOYEE':
            api.post(action.data);
            break;

        case 'DELETE_EMPLOYEE':
            api.delete(action.id);
            break;

        // Do nothing if the action does not interest us
        default:
            break;
    }
};

export default employeeMiddleware;
